export const searchConfig = {
  filters: ["alternative", "category", "stack", "license"] as const,
}
